module.exports = __webpack_public_path__ + "static/media/sf-test-13.f94f64ef.mp3";